var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"d-inline-flex justify-content-center font-weight-normal",class:_vm.statusClass,attrs:{"pill":""}},[_vm._t("default",[_vm._v(_vm._s(_vm.$t(_vm.text)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }